/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type LiveChatMyChatsEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const liveChatMyChatsEntryPoint: EntryPoint<LiveChatMyChatsEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<LiveChatMyChatsEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-live-chat-my-chats", jiraSpaEntry: "async-servicedesk-live-chat-my-chats" */ './LiveChatMyChatsSpa.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
